export default __webpack_public_path__ + "static/media/icon-linkedin_white.efdd004b.svg";